import { render, staticRenderFns } from "./ServiceableTypeEditor.vue?vue&type=template&id=248cf56d&scoped=true"
import script from "./ServiceableTypeEditor.vue?vue&type=script&lang=js"
export * from "./ServiceableTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cf56d",
  null
  
)

export default component.exports